var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "app-wrapper",
      class: _vm.componentClass,
      style: _vm.componentStyle,
      attrs: { id: "app" }
    },
    [
      _vm.topBarType !== _vm.TOP_BARS.NULL && !_vm.$isMiniProgram
        ? [
            _vm.topBarType === _vm.TOP_BARS.INDEX
              ? _c("HomeTopBar")
              : _vm.topBarType === _vm.TOP_BARS.NO_USER
              ? _c("TopBarNoUser")
              : _vm.topBarType === _vm.TOP_BARS.INNER
              ? _c("HomeTopBar", { attrs: { skin: "inner" } })
              : _vm.topBarType === _vm.TOP_BARS.SCHOOL
              ? _c("TopBarSchool")
              : _vm.topBarType === _vm.TOP_BARS.SL
              ? _c("TopBarSl")
              : _vm.topBarType === _vm.TOP_BARS.TEACHER
              ? _c("TopBarTeacher")
              : _vm.topBarType === _vm.TOP_BARS.BY_ROLE
              ? _c("TopBarByRole")
              : _vm.topBarType === _vm.TOP_BARS.TEXT_BLOCK
              ? _c("TopBarTextBlock")
              : _vm.topBarType === _vm.TOP_BARS.BACK
              ? _c("TopBarBack")
              : _c("TopBarDefault"),
            _vm.topBarProcess === _vm.PROCESS.STU_APPLY
              ? _c("StuApplyProcessTopBar")
              : _vm._e()
          ]
        : _vm._e(),
      _c("router-view"),
      _c("SideHelper"),
      _c("FloatingToolbar", { staticClass: "floating-toolbar" }),
      _vm.isShowDeveloperView ? _c("Cheat") : _vm._e(),
      _vm.footerType === _vm.FOOTERS.DEFAULT ? [_c("DefaultFooter")] : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }